import { useAuthStore } from "@/lib/store/auth";

/** The account authenticated now, independent of record authors and schema provenance. */
export function authenticatedAccountId(): string | null {
  const { user, isAuthenticated } = useAuthStore.getState();
  return isAuthenticated ? (user?.id ?? null) : null;
}
